interface FormatMeetingSummaryQuotaSubtitleArgs {
  readonly locale: string;
  readonly usedMinutes: number;
  readonly allowanceMinutes: number;
  readonly t: (key: string, options?: Record<string, unknown>) => string;
  readonly date?: Date;
}

interface FormatMeetingSummaryQuotaResetDateArgs {
  readonly locale: string;
  readonly t: (key: string, options?: Record<string, unknown>) => string;
  readonly date?: Date;
}

const formatMeetingSummaryQuotaSubtitle = ({
  locale,
  usedMinutes,
  allowanceMinutes,
  t,
  date = new Date(Date.now()),
}: FormatMeetingSummaryQuotaSubtitleArgs): string => {
  const month = new Intl.DateTimeFormat(locale, { month: 'long' }).format(date);
  const year = date.getFullYear();

  return t('settings.quotaUsage.subtitle', {
    month,
    year,
    used: usedMinutes,
    total: allowanceMinutes,
  });
};

const formatMeetingSummaryQuotaResetDate = ({
  locale,
  t,
  date = new Date(Date.now()),
}: FormatMeetingSummaryQuotaResetDateArgs): string => {
  const nextMonthFirst = new Date(date.getFullYear(), date.getMonth() + 1, 1);
  const monthNum = nextMonthFirst.getMonth() + 1;
  const dayNum = nextMonthFirst.getDate();
  if (locale === 'ja') {
    const dateStr = `${monthNum}月${dayNum}日`;
    return t('settings.quotaUsage.quotaResetOn', { date: dateStr });
  }
  const dateStr = new Intl.DateTimeFormat(locale, { month: 'long', day: 'numeric' }).format(
    nextMonthFirst,
  );
  return t('settings.quotaUsage.quotaResetOn', { date: dateStr });
};

export { formatMeetingSummaryQuotaResetDate, formatMeetingSummaryQuotaSubtitle };
